module.exports = __webpack_public_path__ + "img/on-air-logo.299246cf.png";